import {IDocViewConfig} from '../interface';

/**
 * 注意！会给外部使用 不要轻易引入ku-mega内部依赖
*/

let configs: IDocViewConfig = {};
export const setConfigs = (config: IDocViewConfig) => {
    configs = config;
};

export const getConfigs = () => {
    return configs;
};
